const NAMESPACE = "addExistingProject";

const KEYS = {
    projectNumberInputLabel: "projectNumberInputLabel",
    findProjectButtonText: "findProjectButtonText",
    projectFoundMessage: "projectFoundMessage",
    projectNotFoundMessage: "projectNotFoundMessage"
};

const MESSAGES = {
    [KEYS.projectNumberInputLabel]: {
        value: "Project number of existing project",
        comment: "Label for the input field where users enter the project number of an existing project"
    },
    [KEYS.findProjectButtonText]: {
        value: "Find Project",
        comment: "Button that tries to find a project with the entered project number"
    },
    [KEYS.projectFoundMessage]: {
        value: "Found project {projectNumber}",
        comment: "Message displayed when a project is found with the entered project number"
    },
    [KEYS.projectNotFoundMessage]: {
        value: "Could not find project {projectNumber}",
        comment: "Message displayed when a project is not found with the entered project number"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
